import { Operation } from "rsql-builder";
import escapeValue, {EscapedValue} from 'rsql-builder/dist/escape-value';

export function like(value) {
    return new Operation(value, "=lk=");
}

export function between(from, to) {
    let values = [from, to]
    if(Array.isArray(from)) {
        values = from;
    }
    return new Operation(new EscapedValue(`(${values.map(escapeValue)})`), "=bt=");
}

export function isNull() {
    return new Operation('', "=nu=");
}

export function isNotNull() {
    return new Operation('', "=nn=");
}